import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Formik } from 'formik';
import RecursiveContainer from './RecursiveContainer';
import * as yup from 'yup';
import GenericButton from '../../common/button';
import useGenerateReport from '../hooks/useGenerateReport';
import { Accordion, Card } from 'react-bootstrap';
import {
  AccordionDownArrow,
  AccordionUpArrow,
} from '../../../img/Reports/ReportsSvgImages';
import ReportsBLOB from './BLOB';
import CustomClientError from 'src/Admin/errorhandling/CustomClientError';
import ReportsDynamicFormSkeleton from '../Skeleton/ReportsDynamicFormSkeleton';

const ReportForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { generateReportHandler } = useGenerateReport();
  const { mandatoryFields, optionalFields, productFields } = useSelector(
    (state) => state?.reports?.generateReport?.dynamicFieldsData,
  );
  const { isServerErrorOnDynamicForm, blobData } = useSelector(
    (state) => state?.reports,
  );
  const { userData } = useSelector((state) => state?.user);
  const { Network_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const { Broker_User_Creation_Setting } = Network_Setting;
  const [uiDynamicFieldsData, setUiDynamicFieldsData] = useState([]);
  const [activeId, setActiveId] = useState('0');
  const [reportsDynamicFieldsSchema, setReportsDynamicFieldsSchema] =
    useState();

  function generateInitialValues(apiResponse) {
    const initialValues = {};
    apiResponse.forEach((field) => {
      initialValues[field.name] = field.defaultValue;
    });
    console.log('values initialValues :', initialValues);
    return initialValues;
  }

  const toggleActive = (id) => {
    if (activeId === id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  };

  const getConvertNaNRequiredChecker = (value, field) => {
    if (
      (isNaN(value) || value === null || value === undefined) &&
      field?.dataType === 'Integer'
    ) {
      return true;
    } else {
      return false;
    }
  };

  function generateSchema(apiResponse) {
    const fields = {};
    apiResponse.forEach((field) => {
      let yupDataTypeValidator = 'string';
      let yupRequiredValidator = field.isRequired === 'true' ? 'required' : '';
      if (field?.dataType === 'Boolean') {
        yupDataTypeValidator = 'boolean';
      } else if (field?.dataType === 'Integer') {
        yupDataTypeValidator = 'number';
      } else if (field?.dataType === 'Date') {
        yupRequiredValidator = field.isRequired === 'true' ? 'required' : '';
      }
      fields[field.name] = yup[yupDataTypeValidator]()
        [yupRequiredValidator ? 'required' : 'notRequired'](
          'This is a required field.',
        )
        .transform((value) =>
          getConvertNaNRequiredChecker(value, field) ? 0 : value,
        );
    });
    return fields;
  }

  useEffect(() => {
    setUiDynamicFieldsData([...mandatoryFields, ...optionalFields]);
  }, [mandatoryFields, optionalFields]);

  useEffect(() => {
    if (uiDynamicFieldsData?.length > 0)
      setReportsDynamicFieldsSchema(
        yup.object().shape(generateSchema(uiDynamicFieldsData)),
      );
  }, [uiDynamicFieldsData]);

  if (uiDynamicFieldsData.length == 0)
    return (
      <div>
        {isServerErrorOnDynamicForm ? (
          <div>
            <CustomClientError
              ErrorHeading="Something went wrong with request!"
              ErrorMessage="Server request failed. Please contact support team."
              CustomClasses="p-0"
            />
          </div>
        ) : (
          <div>
            <ReportsDynamicFormSkeleton />
          </div>
        )}
      </div>
    );

  return (
    <div className="dynamic-fields-and-blob-container">
      <div className="report-setting">
        <div className="mb-5">Report Setting</div>
        <Formik
          initialValues={generateInitialValues([
            ...mandatoryFields,
            ...optionalFields,
          ])}
          validationSchema={reportsDynamicFieldsSchema}
          onSubmit={(values) => {
            const formattedData = {
              Parameters: [...mandatoryFields, ...optionalFields].map(
                (item) => {
                  let tmpValue = '';
                  if (
                    item.value &&
                    /^[0-9]{4}\-[0-9]{1,2}\-[0-9]{1,2}$/.test(item.value)
                  ) {
                    tmpValue = item.value.replace(
                      /(\d{4})-(\d{1,2})-(\d{1,2})/,
                      (match, y, m, d) => {
                        return m + '/' + d + '/' + y;
                      },
                    );
                  } else {
                    tmpValue = item.value;
                  }
                  return { Name: item?.name, Value: tmpValue };
                },
              ),
            };
            //blog employer logic here
            const newFormatedArray = '';
            if (
              blobData &&
              (blobData.blobType === 'single' ||
                blobData.empType === 'single' ||
                blobData.locationType === 'single')
            ) {
              //When any single value selected
              if (
                formattedData.Parameters.find(
                  ({ Name }) => Name === 'BOBbegin',
                ) !== undefined
              ) {
                if (
                  userData?.MappedEnties != null &&
                  userData?.MappedEnties?.length > 0
                ) {
                  formattedData.Parameters = formattedData.Parameters.map(
                    (obj) => {
                      if (obj.Name === 'BOBbegin') {
                        obj.Value = userData.MappedEnties[0]?.BlockOfBusinessID;
                      }
                      if (obj.Name === 'BOBend') {
                        obj.Value = userData.MappedEnties[0]?.BlockOfBusinessID;
                      }
                      return obj;
                    },
                  );
                }
                if (
                  blobData?.selectedBlobData?.BlkOfBusId ||
                  blobData?.selectedBlobData?.from
                ) {
                  formattedData.Parameters = formattedData.Parameters.map(
                    (obj) => {
                      if (obj.Name === 'BOBbegin') {
                        obj.Value =
                          blobData.selectedBlobData.BlkOfBusId ||
                          blobData?.selectedBlobData?.from;
                      }
                      if (obj.Name === 'BOBend') {
                        obj.Value =
                          blobData.selectedBlobData.BlkOfBusId ||
                          blobData?.selectedBlobData?.to;
                      }
                      return obj;
                    },
                  );
                }
              }

              //check default first for Insurance
              if (
                formattedData.Parameters.find(
                  ({ Name }) => Name === 'ClientBegin',
                ) !== undefined &&
                userData?.MappedEnties != null &&
                userData?.MappedEnties[0]?.Client?.length > 0
              ) {
                formattedData.Parameters = formattedData.Parameters.map(
                  (obj) => {
                    if (obj.Name === 'ClientBegin') {
                      obj.Value = userData.MappedEnties[0]?.Client[0]?.ClientID;
                    }
                    if (obj.Name === 'ClientEnd') {
                      obj.Value = userData.MappedEnties[0]?.Client[0]?.ClientID;
                    }
                    return obj;
                  },
                );
              }
              if (
                formattedData.Parameters.find(
                  ({ Name }) => Name === 'ClientBegin',
                ) !== undefined &&
                (blobData.selectedEmployerData.ClientId ||
                  blobData.selectedEmployerData.from)
              ) {
                formattedData.Parameters = formattedData.Parameters.map(
                  (obj) => {
                    if (obj.Name === 'ClientBegin') {
                      obj.Value =
                        blobData.selectedEmployerData.ClientId ||
                        blobData.selectedEmployerData.from;
                    }
                    if (obj.Name === 'ClientEnd') {
                      obj.Value =
                        blobData.selectedEmployerData.ClientId ||
                        blobData.selectedEmployerData.to;
                    }
                    return obj;
                  },
                );
              }

              //location
              if (
                formattedData.Parameters.find(
                  ({ Name }) => Name === 'LocationBegin',
                ) !== undefined &&
                userData?.MappedEnties != null &&
                userData?.MappedEnties[0]?.Client[0]?.Location?.length > 0
              ) {
                formattedData.Parameters = formattedData.Parameters.map(
                  (obj) => {
                    if (obj.Name === 'LocationBegin') {
                      obj.Value =
                        userData.MappedEnties[0]?.Client[0]?.Location[0]?.LocationName;
                    }
                    if (obj.Name === 'LocationEnd') {
                      obj.Value =
                        userData.MappedEnties[0]?.Client[0]?.Location[0]?.LocationName;
                    }
                    return obj;
                  },
                );
              }
              if (
                formattedData.Parameters.find(
                  ({ Name }) => Name === 'LocationBegin',
                ) !== undefined &&
                (blobData.selectedLocationData.LocationName ||
                  blobData.selectedLocationData.from)
              ) {
                formattedData.Parameters = formattedData.Parameters.map(
                  (obj) => {
                    if (obj.Name === 'LocationBegin') {
                      obj.Value =
                        blobData.selectedLocationData.LocationName ||
                        blobData.selectedLocationData.from;
                    }
                    if (obj.Name === 'LocationEnd') {
                      obj.Value =
                        blobData.selectedLocationData.LocationName ||
                        blobData.selectedLocationData.to;
                    }
                    return obj;
                  },
                );
              }
            } else if (blobData.blobType === 'range') {
              formattedData.Parameters = formattedData.Parameters.map((obj) => {
                if (obj.Name === 'BOBbegin') {
                  obj.Value = blobData.selectedBlobData.from;
                }
                if (obj.Name === 'BOBend') {
                  obj.Value = blobData.selectedBlobData.to;
                }
                return obj;
              });

              if (
                formattedData.Parameters.find(
                  ({ Name }) => Name === 'ClientBegin',
                ) !== undefined &&
                userData?.MappedEnties != null &&
                userData?.MappedEnties[0]?.Client?.length > 0
              ) {
                formattedData.Parameters = formattedData.Parameters.map(
                  (obj) => {
                    if (obj.Name === 'ClientBegin') {
                      obj.Value = userData.MappedEnties[0]?.Client[0]?.ClientID;
                    }
                    if (obj.Name === 'ClientEnd') {
                      obj.Value = userData.MappedEnties[0]?.Client[0]?.ClientID;
                    }
                    return obj;
                  },
                );
              }

              if (
                formattedData.Parameters.find(
                  ({ Name }) => Name === 'ClientBegin',
                ) !== undefined &&
                (blobData.selectedEmployerData.ClientId ||
                  blobData.selectedEmployerData.from)
              ) {
                formattedData.Parameters = formattedData.Parameters.map(
                  (obj) => {
                    if (obj.Name === 'ClientBegin') {
                      obj.Value =
                        blobData.selectedEmployerData.from ||
                        blobData.selectedEmployerData.ClientId;
                    }
                    if (obj.Name === 'ClientEnd') {
                      obj.Value =
                        blobData.selectedEmployerData.to ||
                        blobData.selectedEmployerData.ClientId;
                    }
                    return obj;
                  },
                );
              }

              if (
                formattedData.Parameters.find(
                  ({ Name }) => Name === 'LocationBegin',
                ) !== undefined &&
                userData?.MappedEnties != null &&
                userData?.MappedEnties[0]?.Client[0]?.Location?.length > 0
              ) {
                formattedData.Parameters = formattedData.Parameters.map(
                  (obj) => {
                    if (obj.Name === 'LocationBegin') {
                      obj.Value =
                        userData.MappedEnties[0]?.Client[0]?.Location[0]?.LocationName;
                    }
                    if (obj.Name === 'LocationEnd') {
                      obj.Value =
                        userData.MappedEnties[0]?.Client[0]?.Location[0]?.LocationName;
                    }
                    return obj;
                  },
                );
              }

              if (
                formattedData.Parameters.find(
                  ({ Name }) => Name === 'LocationBegin',
                ) !== undefined &&
                (blobData.selectedLocationData.LocationName ||
                  blobData.selectedLocationData.from)
              ) {
                formattedData.Parameters = formattedData.Parameters.map(
                  (obj) => {
                    if (obj.Name === 'LocationBegin') {
                      obj.Value =
                        blobData.selectedLocationData.from ||
                        blobData.selectedLocationData.LocationName;
                    }
                    if (obj.Name === 'LocationEnd') {
                      obj.Value =
                        blobData.selectedLocationData.to ||
                        blobData.selectedLocationData.LocationName;
                    }
                    return obj;
                  },
                );
              }
            } else if (blobData.empType === 'range') {
              if (
                userData?.MappedEnties != null &&
                userData?.MappedEnties != null &&
                userData?.MappedEnties?.length > 0
              ) {
                formattedData.Parameters = formattedData.Parameters.map(
                  (obj) => {
                    if (obj.Name === 'BOBbegin') {
                      obj.Value = userData.MappedEnties[0]?.BlockOfBusinessID;
                    }
                    if (obj.Name === 'BOBend') {
                      obj.Value = userData.MappedEnties[0]?.BlockOfBusinessID;
                    }
                    return obj;
                  },
                );
              }

              formattedData.Parameters = formattedData.Parameters.map((obj) => {
                if (obj.Name === 'ClientBegin') {
                  obj.Value =
                    blobData.selectedEmployerData.from ||
                    blobData.selectedEmployerData.ClientId;
                }
                if (obj.Name === 'ClientEnd') {
                  obj.Value =
                    blobData.selectedEmployerData.to ||
                    blobData.selectedEmployerData.ClientId;
                }
                return obj;
              });

              if (
                formattedData.Parameters.find(
                  ({ Name }) => Name === 'LocationBegin',
                ) !== undefined &&
                userData?.MappedEnties != null &&
                userData?.MappedEnties[0]?.Client[0]?.Location?.length > 0
              ) {
                formattedData.Parameters = formattedData.Parameters.map(
                  (obj) => {
                    if (obj.Name === 'LocationBegin') {
                      obj.Value =
                        userData.MappedEnties[0]?.Client[0]?.Location[0]?.LocationName;
                    }
                    if (obj.Name === 'LocationEnd') {
                      obj.Value =
                        userData.MappedEnties[0]?.Client[0]?.Location[0]?.LocationName;
                    }
                    return obj;
                  },
                );
              }

              if (
                formattedData.Parameters.find(
                  ({ Name }) => Name === 'LocationBegin',
                ) !== undefined &&
                (blobData.selectedLocationData.LocationName ||
                  blobData.selectedLocationData.from)
              ) {
                formattedData.Parameters = formattedData.Parameters.map(
                  (obj) => {
                    if (obj.Name === 'LocationBegin') {
                      obj.Value =
                        blobData.selectedLocationData.from ||
                        blobData.selectedLocationData.LocationName;
                    }
                    if (obj.Name === 'LocationEnd') {
                      obj.Value =
                        blobData.selectedLocationData.to ||
                        blobData.selectedLocationData.LocationName;
                    }
                    return obj;
                  },
                );
              }
            } else if (blobData.locationType === 'range') {
              if (
                userData?.MappedEnties != null &&
                userData?.MappedEnties != null &&
                userData?.MappedEnties?.length > 0
              ) {
                formattedData.Parameters = formattedData.Parameters.map(
                  (obj) => {
                    if (obj.Name === 'BOBbegin') {
                      obj.Value = userData.MappedEnties[0]?.BlockOfBusinessID;
                    }
                    if (obj.Name === 'BOBend') {
                      obj.Value = userData.MappedEnties[0]?.BlockOfBusinessID;
                    }
                    return obj;
                  },
                );
              }
              if (
                formattedData.Parameters.find(
                  ({ Name }) => Name === 'ClientBegin',
                ) !== undefined &&
                userData?.MappedEnties != null &&
                userData?.MappedEnties[0]?.Client?.length > 0
              ) {
                formattedData.Parameters = formattedData.Parameters.map(
                  (obj) => {
                    if (obj.Name === 'ClientBegin') {
                      obj.Value = userData.MappedEnties[0]?.Client[0]?.ClientID;
                    }
                    if (obj.Name === 'ClientEnd') {
                      obj.Value = userData.MappedEnties[0]?.Client[0]?.ClientID;
                    }
                    return obj;
                  },
                );
              }
              formattedData.Parameters = formattedData.Parameters.map((obj) => {
                if (obj.Name === 'LocationBegin') {
                  obj.Value =
                    blobData.selectedLocationData.from ||
                    blobData.selectedLocationData.LocationName;
                }
                if (obj.Name === 'LocationEnd') {
                  obj.Value =
                    blobData.selectedLocationData.to ||
                    blobData.selectedLocationData.LocationName;
                }
                return obj;
              });
            } else {
              //When super user we pass default values other wise login user blob and etc..
              if (
                formattedData.Parameters.find(
                  ({ Name }) => Name === 'BOBbegin',
                ) !== undefined &&
                userData?.MappedEnties != null &&
                userData?.MappedEnties != null &&
                userData?.MappedEnties?.length > 0
              ) {
                formattedData.Parameters = formattedData.Parameters.map(
                  (obj) => {
                    if (obj.Name === 'BOBbegin') {
                      obj.Value = userData.MappedEnties[0]?.BlockOfBusinessID;
                    }
                    if (obj.Name === 'BOBend') {
                      obj.Value = userData.MappedEnties[0]?.BlockOfBusinessID;
                    }
                    return obj;
                  },
                );
              }

              if (
                formattedData.Parameters.find(
                  ({ Name }) => Name === 'ClientBegin',
                ) !== undefined &&
                userData?.MappedEnties != null &&
                userData?.MappedEnties[0]?.Client?.length > 0
              ) {
                formattedData.Parameters = formattedData.Parameters.map(
                  (obj) => {
                    if (obj.Name === 'ClientBegin') {
                      obj.Value = userData.MappedEnties[0]?.Client[0]?.ClientID;
                    }
                    if (obj.Name === 'ClientEnd') {
                      obj.Value = userData.MappedEnties[0]?.Client[0]?.ClientID;
                    }
                    return obj;
                  },
                );
              }

              if (
                formattedData.Parameters.find(
                  ({ Name }) => Name === 'LocationBegin',
                ) !== undefined &&
                userData?.MappedEnties != null &&
                userData.MappedEnties[0]?.Client[0]?.Location?.length > 0
              ) {
                formattedData.Parameters = formattedData.Parameters.map(
                  (obj) => {
                    if (obj.Name === 'LocationBegin') {
                      obj.Value =
                        userData.MappedEnties[0]?.Client[0]?.Location[0]?.LocationName;
                    }
                    if (obj.Name === 'LocationEnd') {
                      obj.Value =
                        userData.MappedEnties[0]?.Client[0]?.Location[0]?.LocationName;
                    }
                    return obj;
                  },
                );
              }
            }
            //debugger;
            //console.log('=======================');
            //console.log(blobData)
            console.log('values =>', formattedData, values);
            generateReportHandler(formattedData);
          }}
        >
          {({ handleSubmit, handleChange, errors }) => (
            <form onSubmit={handleSubmit}>
              <Accordion defaultActiveKey="0">
                {[...mandatoryFields, ...optionalFields]?.filter((item) =>
                  ['BOBbegin', 'BOBend'].includes(item.name),
                ).length > 0 && (
                  <div
                    className={`panel-wrap provider-details-info mb-3 w-100 ${
                      activeId === '2' ? ' active-panel' : ''
                    }`}
                  >
                    <Accordion.Toggle
                      as={Card.Header}
                      onClick={() => toggleActive('2')}
                      className="panel-toggle text-left w-100 accordion-top-part"
                      eventKey="2"
                    >
                      <div className="d-flex panel-card-header">
                        <span className="accordion-arrow">
                          {activeId === '2' ? (
                            <AccordionDownArrow className="acc-arrow" />
                          ) : (
                            <AccordionUpArrow className="acc-arrow" />
                          )}
                        </span>
                        <span className="accordion-name">
                          {userData.UserType !== 'Client' &&
                          userData.UserType !== 'Broker'
                            ? 'Block Of Business(es)/Employer(s)'
                            : userData.UserType === 'Broker' &&
                              Broker_User_Creation_Setting === true
                            ? 'Block Of Business(es)/Employer(s)'
                            : 'Employer(s)'}

                          <span className="required-mark"> *</span>
                        </span>
                      </div>
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="2">
                      <Card.Body>
                        <ReportsBLOB />
                      </Card.Body>
                    </Accordion.Collapse>
                  </div>
                )}

                {mandatoryFields?.filter((item) => item?.isDisplay === true)
                  ?.length > 0 && (
                  <div
                    className={`panel-wrap provider-details-info mb-3 w-100 ${
                      activeId === '0' ? ' active-panel' : ''
                    }`}
                  >
                    <Accordion.Toggle
                      as={Card.Header}
                      onClick={() => toggleActive('0')}
                      className="panel-toggle text-left w-100 accordion-top-part"
                      eventKey="0"
                    >
                      <div className="d-flex panel-card-header">
                        <span className="accordion-arrow">
                          {activeId === '0' ? (
                            <AccordionDownArrow className="acc-arrow" />
                          ) : (
                            <AccordionUpArrow className="acc-arrow" />
                          )}
                        </span>
                        <span className="accordion-name">
                          Mandatory Fields{' '}
                          <span className="required-mark"> *</span>
                        </span>
                      </div>
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="0">
                      <Card.Body>
                        <RecursiveContainer
                          config={mandatoryFields}
                          handleChangeFormik={handleChange}
                          formikErr={errors}
                        />
                      </Card.Body>
                    </Accordion.Collapse>
                  </div>
                )}
                {optionalFields?.filter((item) => item?.isDisplay === true)
                  ?.length > 0 && (
                  <div
                    className={`panel-wrap provider-details-info mb-3 w-100 ${
                      activeId === '1' ? ' active-panel' : ''
                    }`}
                  >
                    <Accordion.Toggle
                      as={Card.Header}
                      onClick={() => {
                        toggleActive('1');
                      }}
                      className="panel-toggle text-left w-100 accordion-top-part"
                      eventKey="1"
                    >
                      <div className="d-flex panel-card-header">
                        <span className="accordion-arrow">
                          {activeId === '1' ? (
                            <AccordionDownArrow className="acc-arrow" />
                          ) : (
                            <AccordionUpArrow className="acc-arrow" />
                          )}
                        </span>
                        <span className="accordion-name">Optional Field</span>
                      </div>
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="1">
                      <Card.Body>
                        <RecursiveContainer
                          config={optionalFields}
                          handleChangeFormik={handleChange}
                          formikErr={errors}
                        />
                      </Card.Body>
                    </Accordion.Collapse>
                  </div>
                )}
              </Accordion>

              <div className="report-form-devider" />
              <div className="generate-button-container">
                <GenericButton
                  type="submit"
                  variant="primary"
                  tabIndex={0}
                  ariaLabel="Click to generate report"
                  className="button-classes"
                  disabled={Boolean(Object.keys(errors).length > 0)}
                >
                  Generate Report
                </GenericButton>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ReportForm;
